
import { Icon, InlineIcon } from "@iconify/vue";
import plusIcon from "@iconify-icons/dashicons/plus-alt2";
import removeIcon from "@iconify-icons/dashicons/remove";

import { defineComponent } from "vue";

export default defineComponent({
  name: "ManageList",
  data() {
    return {
      inputText: "" as string | null,
      icons: {
        plus: plusIcon,
        remove: removeIcon,
      },
    };
  },
  props: {
    itemLabel: String,
    list: Array,
    namedRoute: String,
  },
  components: {
    Icon,
  },
  methods: {
    addItem() {
      if (this.inputText) {
        const foundItem = this.list?.find((item: any) => {
          return item.name === this.inputText;
        });
        if (foundItem) {
          return;
        }
        this.$emit("item-added", {
          name: this.inputText,
        });
        this.inputText = null;
      }
    },
    removeItem(item: any) {
      this.$emit("item-removed", item);
    },
  },
});
